
import { Component, Vue, Prop } from 'vue-property-decorator';
import { Route } from 'vue-router';
import DateTimePicker from '@/components/DateTimePicker.vue';
import ruleMixin from '@/minix/ruleMixin';
import api from '@/api';
import imageConvert from '@/utils/image';
import Swal from 'sweetalert2';

const { shoppingGuide } = api;

@Component({
  components: {
    DateTimePicker,
  },
  mixins: [ruleMixin],
})
export default class ShoppingGuideForm extends Vue {
  @Prop() private id!: string;

  private loading = false;

  private valid = true;

  private form = {
    name: '',
    iconUrl: '',
    isEnabled: true,
    sort: 0,
    startOn: null,
    endOn: null,
    url: '',
    pointBackPercentage: 0,
  };

  private get checkImage() {
    return [() => !!this.form.iconUrl || 'ICON 沒有圖片'];
  }

  private async addImage(event: File) {
    if (event) {
      (this.$refs.fileUploader as any).clearableCallback();
      // 過濾重複上傳
      const base64 = await imageConvert(event);
      this.form.iconUrl = base64;
    }
  }

  private async submit() {
    if ((this.$refs.form as any).validate()) {
      this.loading = true;
      const { status } = this.isEdit
        ? await shoppingGuide.edit(this.id, this.form)
        : await shoppingGuide.add(this.form);
      this.loading = false;
      if (status === 1) {
        await Swal.fire({ icon: 'success', title: `${this.title}成功` });
        await this.$router.back();
      }
    }
  }

  private async cancel() {
    await this.$router.back();
  }

  private get isEdit() {
    return !!this.id;
  }

  private get title() {
    return this.isEdit ? '修改' : '新增';
  }

  private async setForm(form: any) {
    this.form = form;
  }

  private async beforeRouteEnter(
    to: Route,
    from: Route,
    next: (to?: ((vm: ShoppingGuideForm) => void) | boolean) => void,
  ) {
    if (to.name === 'shoppingGuideEdit') {
      const { data } = await shoppingGuide.get(to.params.id);
      await next(async (vm) => {
        vm.setForm(data);
      });
    } else {
      await next(true);
    }
  }
}
